module.exports = __webpack_public_path__ + "img/blood_event_line.52084075.gif";